<template>
  <div>
    <top-header />
    <div class="mt-16">
      <slot />
    </div>
    <bottom-footer />
    <slot name="modal"></slot>
  </div>
</template>

<script>
import topHeader from "./Front/Header";
import bottomFooter from "./Front/Footer";

export default {
  components: {
    topHeader,
    bottomFooter,
  },
  props: {
    title: String,
  },
  data() {
    return { baseTitle: "2nrace" };
  },
  watch: {
    title: {
      immediate: true,
      handler(title) {
        if (title !== undefined) {
          document.title = title + " - " + this.baseTitle;
        } else {
          document.title = this.baseTitle;
        }
      },
    },
    "$page.flash": {
      handler() {
        if (this.$page.flash.success) {
          this.$toast.open({
            message: this.$page.flash.success,
            type: "success",
          });
        } else if (this.$page.flash.error) {
          this.$toast.open({
            message: this.$page.flash.error,
            type: "error",
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
